/* unplugin-vue-components disabled */import { render } from "./EventsBlock.vue?vue&type=template&id=bde37a84"
import script from "./EventsBlock.vue?vue&type=script&lang=js"
export * from "./EventsBlock.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/lightandnight/lightandnight/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__